import axios from "axios";
import * as Config from "../../../Utils/config";




/// old service 
//show basket cart

export async function AddToCartPlan(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}api/list/addtocartplan`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}


export async function ShowBasketCartList(client_id, token) {
    try {


        const response = await axios.get(
            `${Config.base_url}api/list/basketcartlist/${client_id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        return response.data;

    } catch (error) {
        console.error("Error fetching cart items:", error);
        return {
            status: false,
            message: error.response?.data?.message || "Something went wrong.",
        };
    }
}



//add to cart Basket

export async function AddToCartBasket(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}api/list/addtocartbasket`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}



//delete basket item

export async function DeleteBasketCartItem(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}api/list/deletecartitem`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}



// buy Basket cart items

export async function Addbasketsubscriptionaddtocartdata(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}api/list/addbasketsubscriptionaddtocart`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}



export async function ShowPlanCartList(client_id, token) {
    try {


        const response = await axios.get(
            `${Config.base_url}api/list/plancartlist/${client_id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        return response.data;

    } catch (error) {
        console.error("Error fetching cart items:", error);
        return {
            status: false,
            message: error.response?.data?.message || "Something went wrong.",
        };
    }
}


export async function DeletPlanCartItem(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}api/list/deletecartitem`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}


// export async function Addplansubscriptionaddtocart(data, token) {
//     try {
//         const res = await axios.post(
//             `${Config.base_url}api/list/addplansubscriptionaddtocart`,
//             data,
//             {
//                 headers: {
//                     data: {},
//                     Authorization: `${token}`,
//                 },
//             }
//         );

//         return res?.data;
//     } catch (err) {
//         return err.response?.data || err.message;
//     }
// }



export async function AddplanSubscription(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}api/list/addplansubscriptionaddtocart`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}




export async function BasketSubscriptionCount(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}api/list/BasketSubscriptionCount`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}


// complain data 


export async function addorupdatecomplaindata(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}dashboard/addorupdatecomplain`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}



export async function addrrupdategrievancedata(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}dashboard/addrrupdategrievance`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}


export async function addorupdateregulatorydata(data, token) {
    try {
        const res = await axios.post(
            `${Config.base_url}dashboard/addorupdateregulatory`,
            data,
            {
                headers: {
                    data: {},
                    Authorization: `${token}`,
                },
            }
        );

        return res?.data;
    } catch (err) {
        return err.response?.data || err.message;
    }
}





export async function getcomplaindata(token) {
    try {


        const response = await axios.get(
            `${Config.base_url}dashboard/getcomplain`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        return response.data;

    } catch (error) {
        console.error("Error fetching cart items:", error);
        return {
            status: false,
            message: error.response?.data?.message || "Something went wrong.",
        };
    }
}



export async function getgrievancedata(token) {
    try {


        const response = await axios.get(
            `${Config.base_url}dashboard/getgrievance`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        return response.data;

    } catch (error) {
        console.error("Error fetching cart items:", error);
        return {
            status: false,
            message: error.response?.data?.message || "Something went wrong.",
        };
    }
}


export async function getregulatorydata(token) {
    try {


        const response = await axios.get(
            `${Config.base_url}dashboard/getregulatory`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        return response.data;

    } catch (error) {
        console.error("Error fetching cart items:", error);
        return {
            status: false,
            message: error.response?.data?.message || "Something went wrong.",
        };
    }
}
